export default __webpack_public_path__ + "static/media/mike.5c93612c.jpg";